export default __webpack_public_path__ + "static/media/map.35f971ac.svg";